import React from 'react';
import {  TextareaItem } from 'antd-mobile';
import WrapComponent from './WrapComponent';
const isIOS = /iphone|iPhone|ipad|ipod|ios/i.test(navigator.userAgent);
const isSafri = (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent));

class  LongText extends React.Component{
    render(){
        let {api_name, max_length, is_readonly, default_value, is_required, label, errorText, form} = this.props;
        const { getFieldProps } = form;

        let tempProps = {
            type: 'text',
            placeholder: $st('请输入'),
            name: api_name,
            disabled: is_readonly,
            rows: 4
        }
        let fieldProps = getFieldProps(api_name, {
            initialValue: default_value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st(`paas.smart.form.isrequired`)
                },{
                    type: 'string',
                    whitespace: true,
                    message: `${label}`+$st(`不能为空`)
                }]
            }],
            normalize: function(v, prev){
                if (v && v.length > max_length){
                    return v.slice(0, max_length);
                }else{
                    return v;
                }
            }
        })

        let value = form.getFieldValue(api_name) || '';
        let classes = ['long-text__num', errorText ? 'long-text_error' : '']
        let textareaClass = isIOS ? 'iosColor' : isSafri ? 'isSafri' : ''
        return (
            <div className='long-text-wrap'>
                <TextareaItem className={textareaClass} {...tempProps} {...fieldProps} />
                <span className={classes.join(' ')}>{`${value.length}/${max_length}`}</span>
                {errorText && <div className='input-error'>{errorText}</div>}
            </div>
        )
    }
}
export default WrapComponent(LongText);



// WEBPACK FOOTER //
// ./src/component/LongText.js